import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { AdvanceInvoiceOptionEnums } from 'src/app/enum/advance-invoice-option-enum';
import { ClientStateEnums } from 'src/app/enum/client-state-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { IvaTypeEnums } from 'src/app/enum/iva-type-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { AccountingModelService } from 'src/app/services/management/accounting-model.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-cost-center',
  templateUrl: './register-cost-center.component.html',
  styleUrls: ['./register-cost-center.component.scss'],
  standalone: false
})
export class RegisterCostCenterComponent implements OnInit {

  @ViewChild('selectArticleForCostCenter') articleModalComponent?: CustomModalComponent | null = null;
  ascendantArticle: boolean = true;
  branchId: number = 0;
  clientId: number = 0;
  code: number = 0;
  codeNameClient: string = '';
  codeNameEnterprise: string = '';
  columnSortArticle: string | null = null;
  companyId: number = 0;
  component = CustomTableSelectComponent;
  costCenterContract: CostCenterModel = new CostCenterModel();
  costCenterId: number = 0;
  disabledFormInvoicing: boolean = false;
  disabledButtonSave: boolean = false;
  dataArticles: PagedResponseModel<ArticleSelectionTableModel> = new PagedResponseModel<ArticleSelectionTableModel>();
  enterpriseId: number = 0;
  filtersArticle: ColumnResponseModel[] = []
  formCostCenter: FormGroup = new FormGroup({});
  headerArticles: ColumnResponseModel[] = [];
  inputsForArticlesSelect$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
  });
  isOpened: string | undefined = undefined;
  ivaTypeId: number = 0;
  limitArticle: number = 10;
  listAccountingModels: CustomListDropdown[] = [];
  listArticles: any[] = [];
  listBranches: CustomListDropdown[] = [];
  listConstructionSites: CustomListDropdown[] = [];
  listCostCenterTypes: CustomListDropdown[] = [];
  listInvoicingModels: CustomListDropdown[] = [];
  listIvaTypes: CustomListDropdown[] = [];
  listConceptInvoicings: CustomListDropdown[] = [];
  listOptionAdvanceInvoice: CustomListDropdown[] = [
    { label: 'No calcula diferencia', value: 1 },
    { label: 'Calcula diferencia pero no factura', value: 2 },
    { label: 'Calcula diferencia y factura', value: 3 }
  ];
  listPriceLists: CustomListDropdown[] = [];
  nameWindow: string = 'Captura Centros de Costos';
  output$ = new Subject<any>();
  pageArticle: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  subscription: Subscription;
  swAdvanceInvoice: boolean = false;
  swDispersedArticle: boolean = false;
  url: string = "cost-center";
  visibleInvoiceM2: boolean = false;
  visibleFixedQuota: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,
    private accountingModelService: AccountingModelService,
    private articleService: ArticleService,
    private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private costCenterService: CostCenterService,
    private cdr: ChangeDetectorRef,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private formControlStateService: FormControlStateService,
    private generalParameterService: GeneralParameterService,
    private headerService: HeaderService,
    private location: Location,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.validateForm(this.costCenterContract);
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.costCenterId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    this.resetCostCenterData();
    await this.getAllLists(true);
    this.validateForm(this.costCenterContract);
    await this.getIvaType(IvaTypeEnums.pleno);
    this.location.replaceState(`/${this.url}/register`);
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formCostCenter.get("branchId")?.value;
    this.code = this.formCostCenter.get("code")?.value;
    if (this.branchId == null || this.branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (this.code == null) {
      this.code = 0;
    }
    await this.handleCostCenterNavigation(buttonClick, this.branchId, this.code)
  }

  async changeCode() {
    const branchId = this.formCostCenter.get("branchId")?.value;
    let code = this.formCostCenter.get("code")?.value;
    if (this.costCenterContract.code == code) return;
    if (branchId == null || branchId == 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (code == 0) {
      code = null;
    }
    this.branchId = branchId
    this.code = code;
    if (code == null) {
      this.costCenterId = 0;
      this.costCenterContract = new CostCenterModel();
      this.costCenterContract.branchId = branchId;
    } else {
      try {
        const response = await firstValueFrom(this.costCenterService.getCostCenterByCode(branchId, code));
        this.costCenterId = response.costCenterId;
        this.costCenterContract = response;
        this.validateForm(this.costCenterContract);
        this.location.replaceState(`/${this.url}/register/${this.costCenterId}`);
      } catch (error) {
        this.costCenterContract = new CostCenterModel();
        this.costCenterContract.costCenterId = -1;
        this.costCenterContract.branchId = branchId;
        this.costCenterContract.code = code;
        console.error('Error al buscar la obra por codigo.', error);
      }
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para crear centros de costos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.resetCostCenterData();
    this.validateForm(this.costCenterContract);
    await this.getIvaType(IvaTypeEnums.pleno);
    this.location.replaceState(`/${this.url}/register`);
  }

  async deleteCostCenter() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar centros de costos. Comuníquese con el administrador del sistema.`
      );
      return;
    }

    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el centros de costos?')) {
      try {
        await firstValueFrom(this.costCenterService.deleteCostCenter(this.costCenterContract.costCenterId));
        this.createNewRegister();
        this.toastHandlerService.showToast(
          'success',
          'El centros de costos fue eliminado exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar el centros de costos.', error);
      }
    }
  }

  async getAllArticlesForSelect() {
    try {
      this.dataArticles = await firstValueFrom(
        this.costCenterService.getArticlesForCostCenters(
          this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de articulos.', error);
    }
  }

  async getAllLists(reload: boolean): Promise<boolean> {
    try {
      if (reload) {
        const [constructionSites, priceLists] = await Promise.all([
          firstValueFrom(this.costCenterService.getConstructionSitesForSelect(this.branchId)),
          firstValueFrom(this.costCenterService.getPriceListsForSelect(this.branchId)),
        ]);
        this.listConstructionSites = constructionSites;
        this.listPriceLists = priceLists;
      } else {
        const [accountingModels, articles, branches, costCenterTypes, priceLists, constructionSites, invoicingModels, ivaTypes, conceptInvoicings] = await Promise.all([
          firstValueFrom(this.accountingModelService.getAllAccountingModelsForSelectAsync()),
          firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
          firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
          firstValueFrom(this.costCenterService.getCostCenterTypesForSelect()),
          firstValueFrom(this.costCenterService.getPriceListsForSelect(this.branchId)),
          firstValueFrom(this.costCenterService.getConstructionSitesForSelect(this.branchId)),
          firstValueFrom(this.costCenterService.getInvoicingModelsForSelectAsync()),
          firstValueFrom(this.costCenterService.getIvaTypesForSelect()),
          firstValueFrom(this.costCenterService.getConceptInvoicingsForSelect()),
        ]);
        this.listAccountingModels = accountingModels;
        this.listArticles = articles;
        this.listBranches = branches;
        this.listCostCenterTypes = costCenterTypes;
        this.listPriceLists = priceLists;
        this.listConstructionSites = constructionSites;
        this.listInvoicingModels = invoicingModels;
        this.listIvaTypes = ivaTypes;
        this.listConceptInvoicings = conceptInvoicings;
      }
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticles.length === 0) {
        this.headerArticles = await firstValueFrom(this.costCenterService.getColumnsForArticles());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getCostCenterById() {
    try {
      const response = await firstValueFrom(this.costCenterService.getCostCenterById(this.costCenterId));
      this.costCenterContract = response;
      const branchChanged = this.branchId != response.branchId;
      if (branchChanged) {
        this.branchId = response.branchId;
        await this.getAllLists(true);
        this.cdr.detectChanges();
      }
      this.code = response.code;
      this.validateForm(this.costCenterContract);
    } catch (error) {
      console.error('Error al obtener el centro de costos.', error);
    }
  }

  async getArticleForSelectAsync(articleId: number | null) {
    if (articleId != null && articleId != 0) {
      try {
        const response = await firstValueFrom(this.costCenterService.getArticleForSelectAsync(articleId));
        this.formCostCenter.controls["articleId"].patchValue(response.value);
      } catch (error) {
        console.error('Error al obtener el articulo.', error);
      }
    }
  }

  async getEnterpriseAndClientByConstructionSiteIdAsync(constructionSiteId: number | null, reload: boolean) {
    if (constructionSiteId != null && constructionSiteId != 0) {
      try {
        const response = await firstValueFrom(
          this.costCenterService.getEnterpriseAndClientByConstructionSiteIdAsync(constructionSiteId)
        );
        this.codeNameEnterprise = response.labelEnterprise;
        this.codeNameClient = response.labelClient;
        this.clientId = response.clientId;
        const isClientInactive = response.clientStateId !== ClientStateEnums.activo;
        if (isClientInactive && reload) {
          this.toastHandlerService.showToast(
            'warning',
            `El cliente ${this.codeNameClient} no se encuentra activo. Debe activarlo para guardar el centro de costos.`
          );
        }
      } catch (error) {
        console.error('Error al obtener empresa y cliente.', error);
        this.codeNameEnterprise = '';
        this.codeNameClient = '';
      }
    } else {
      this.codeNameEnterprise = '';
      this.codeNameClient = '';
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const response = await firstValueFrom(this.userAuthenticatedService.branchObservable
        .pipe(filter(branch => branch && branch.branchId !== 0)));
      this.branchId = response.branchId;
      this.companyId = response.companyId;
      await this.getFirstEnterpriseByBranch(response.branchId);
    } catch (error) {
      console.error('Error al obtener la sucursal principal del usuario autenticado.', error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number | null) {
    if (branchId != null && branchId != 0) {
      try {
        const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
        if (response) {
          this.codeNameEnterprise = `${response.code} - ${response.businessName}`;
        } else {
          this.codeNameEnterprise = '';
          return;
        }
      } catch (error) {
        console.error('Error al buscar la primera empresa de la sucursal.', error);
      }
    }
  }

  async getGeneralParameter() {
    if (this.companyId != null && this.companyId != 0) {
      try {
        const response = await firstValueFrom(this.generalParameterService.getGeneralParametersByCompany(this.companyId));
        this.swAdvanceInvoice = response.find(x => x.generalParameterId == GeneralParameterEnums.facturaAnticipada) != null;
        this.swDispersedArticle = response.find(x => x.generalParameterId == GeneralParameterEnums.activaModelosContables) != null;
      } catch (error) {
        console.error('Error al obtener parámetros generales:', error);
      }
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await this.getFirstBranchByUserAuthenticatedAsync();
    await this.getGeneralParameter();
    await Promise.all([
      this.getAllLists(false),
      this.getPermissionProfileByUrl(),
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  private async handleCostCenterNavigation(buttonClick: any, branchId: number, code: number) {
    const actionMap: Record<string, () => Promise<CostCenterModel>> = {
      first: async () =>
        await firstValueFrom(this.costCenterService.getFirstCostCenterByKeysAsync(branchId)),
      previus: async () =>
        await firstValueFrom(this.costCenterService.getPreviusCostCenterByKeysAsync(branchId, code)),
      next: async () =>
        await firstValueFrom(this.costCenterService.getNextCostCenterByKeysAsync(branchId, code)),
      last: async () =>
        await firstValueFrom(this.costCenterService.getLastCostCenterByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.costCenterId = 0;
      this.costCenterContract = new CostCenterModel();
      this.costCenterContract.branchId = branchId;
      return;
    }
    try {
      const costCenter = await action();
      this.costCenterId = costCenter.costCenterId;
      this.costCenterContract = costCenter;
      this.validateForm(costCenter);
      this.location.replaceState(`/${this.url}/register/${this.costCenterId}`);
    } catch (error) {
      this.costCenterContract = new CostCenterModel();
      this.costCenterContract.costCenterId = 0;
      this.costCenterContract.branchId = branchId;
      this.costCenterContract.code = code;
      console.error(`Error al buscar la obra (${buttonClick.target.id}).`, error);
    }
  }

  async handleInitialState() {
    if (this.costCenterId !== null && this.costCenterId !== 0) {
      await this.getCostCenterById();
    } else {
      this.createNewRegister();
    }
  }

  onChange(check: boolean, swName: string): void {
    const controlMap: Record<string, keyof typeof this.costCenterContract> = {
      swInvoiceM2: 'unitValueM2',
      swFixedQuota: 'valueFixedQuota',
      swAdvanceInvoice: 'advanceInvoiceOption'
    };
    const controlName = controlMap[swName];
    if (!controlName) return;
    let originalValue = this.costCenterContract[controlName] ?? 0;
    if (swName === 'swAdvanceInvoice' && this.costCenterContract.advanceInvoiceOption == null) {
      originalValue = AdvanceInvoiceOptionEnums.notCalculateDifference;
    }
    const control = this.formCostCenter.get(controlName);
    if (!control) return;
    if (check) {
      control.patchValue(originalValue);
      control.enable();
    } else {
      control.patchValue(0);
      control.disable();
    }
  }

  openAccountingModel() {
    const accountingModelId = this.formCostCenter.get("accountingModelId")?.value;
    if (accountingModelId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/accounting-model/register/${accountingModelId}`])
      );
      window.open(url, '_blank');
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe seleccionar un módelo contable.'
      );
    }
  }

  openInvoicingModel() {
    const invoicingModelId = this.formCostCenter.get("invoicingModelId")?.value;
    if (invoicingModelId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/invoicing-model/register/${invoicingModelId}`])
      );
      window.open(url, '_blank');
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe seleccionar un módelo de facturación.'
      );
    }
  }

  async getIvaType(ivaTypeId: number) {
    this.ivaTypeId = ivaTypeId;
    const controls = this.formCostCenter.controls;
    controls["ivaTypeId"].patchValue(ivaTypeId);
    if (ivaTypeId === IvaTypeEnums.pleno) {
      this.disabledFormInvoicing = true;
      const resetFields = [
        "administrationRate", "incidentalRate", "utilityRate", "articleId", "conceptInvoicingId"
      ];
      resetFields.forEach(field => controls[field].patchValue(null));
      setTimeout(() => {
        this.formControlStateService.setControlState(this.formCostCenter, [
          "administrationRate", "incidentalRate", "utilityRate", "conceptInvoicingId", "articleId"
        ], false);
      });
    } else {
      this.disabledFormInvoicing = false;
      await this.getArticleForSelectAsync(this.costCenterContract.articleId);
      if (this.permissionUpdatable) {
        setTimeout(() => {
          this.formControlStateService.setControlState(this.formCostCenter, [
            "administrationRate", "incidentalRate", "utilityRate", "conceptInvoicingId", "articleId"
          ], true);
        });
      }
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getAllArticlesForSelect();
  }

  async openArticleAIUModal() {
    if ((this.costCenterContract.costCenterId != 0 && this.ivaTypeId != IvaTypeEnums.pleno) ||
      this.costCenterContract.costCenterId == 0 && this.ivaTypeId != IvaTypeEnums.pleno) {
      this.filtersArticle = [];
      await Promise.all([
        this.getColumnsArticle(),
        this.getAllArticlesForSelect()
      ]);
      this.updateInputs();
      this.articleModalComponent && this.articleModalComponent.show();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Para elegir un artículo AIU, el tipo de IVA debe ser diferente a "Pleno".'
      );
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  resetCostCenterData() {
    this.costCenterId = 0;
    this.costCenterContract = new CostCenterModel();
    this.costCenterContract.branchId = this.branchId;
    this.codeNameClient = '';
  }

  async send() {
    Object.keys(this.formCostCenter.controls).forEach(key => {
      const control = this.formCostCenter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    const modelCostCenter = this.formCostCenter.value as CostCenterModel;
    if (this.formCostCenter.valid) {
      //Hago null, los campos que permiten ser nulos:
      if (modelCostCenter.articleId == 0) modelCostCenter.articleId = null;
      if (modelCostCenter.conceptInvoicingId == 0) modelCostCenter.conceptInvoicingId = null;
      if (modelCostCenter.alterCode?.trim() == "") modelCostCenter.alterCode = null;
      if (modelCostCenter.observation?.trim() == "") modelCostCenter.observation = null;
      if (modelCostCenter.advanceInvoiceOption == 0) modelCostCenter.advanceInvoiceOption = null;
      modelCostCenter.clientId = this.clientId;
      if (this.swDispersedArticle) {
        if (modelCostCenter.accountingModelId == 0 || modelCostCenter.accountingModelId == null) {
          this.toastHandlerService.showToast(
            'warning',
            'El modelo contable es obligatorio.'
          );
          return;
        }
      } else {
        modelCostCenter.accountingModelId = this.listAccountingModels[0].value as number;
      }
      if (this.costCenterId == 0) {
        try {
          const response = await firstValueFrom(this.costCenterService.createCostCenter(modelCostCenter));
          this.costCenterId = response.costCenterId;
          this.costCenterContract = response;
          this.validateForm(this.costCenterContract);
          this.location.replaceState(`/${this.url}/register/${this.costCenterId}`);
          this.toastHandlerService.showToast(
            'success',
            'El centro de costos fue creado exitosamente'
          );
        } catch (error) {
          console.error('Error al crear el centro de costos.', error);
        }
      } else {
        this.costCenterContract.branchId = modelCostCenter.branchId;
        this.costCenterContract.alterCode = modelCostCenter.alterCode;
        this.costCenterContract.name = modelCostCenter.name;
        this.costCenterContract.costCenterTypeId = modelCostCenter.costCenterTypeId;
        this.costCenterContract.clientId = modelCostCenter.clientId;
        this.costCenterContract.constructionSiteId = modelCostCenter.constructionSiteId;
        this.costCenterContract.priceListId = modelCostCenter.priceListId;
        this.costCenterContract.swInvoiceM2 = modelCostCenter.swInvoiceM2;
        this.costCenterContract.unitValueM2 = modelCostCenter.unitValueM2;
        this.costCenterContract.swFixedQuota = modelCostCenter.swFixedQuota;
        this.costCenterContract.valueFixedQuota = modelCostCenter.valueFixedQuota;
        this.costCenterContract.invoicingModelId = modelCostCenter.invoicingModelId;
        this.costCenterContract.ivaTypeId = modelCostCenter.ivaTypeId;
        this.costCenterContract.administrationRate = modelCostCenter.administrationRate;
        this.costCenterContract.incidentalRate = modelCostCenter.incidentalRate;
        this.costCenterContract.utilityRate = modelCostCenter.utilityRate;
        this.costCenterContract.articleId = modelCostCenter.articleId;
        this.costCenterContract.conceptInvoicingId = modelCostCenter.conceptInvoicingId;
        this.costCenterContract.ratePromptPayment = modelCostCenter.ratePromptPayment;
        this.costCenterContract.observation = modelCostCenter.observation;
        this.costCenterContract.swAdvanceInvoice = modelCostCenter.swAdvanceInvoice;
        this.costCenterContract.advanceInvoiceOption = modelCostCenter.advanceInvoiceOption;
        this.costCenterContract.accountingModelId = modelCostCenter.accountingModelId;
        try {
          const response = await firstValueFrom(this.costCenterService.updateCostCenter(this.costCenterContract));
          this.costCenterContract = response;
          this.validateForm(this.costCenterContract);
          this.toastHandlerService.showToast(
            'success',
            'El centro de costos fue modificado exitosamente'
          );
        } catch (error) {
          console.error('Error al actualizar el centro de costos.', error);
        }
      }
    } else {
      if (modelCostCenter.ivaTypeId == IvaTypeEnums.sobreUtilidad) {
        if (!modelCostCenter.administrationRate) {
          this.toastHandlerService.showToast(
            'warning',
            'El Porcentaje de Administración es obligatorio'
          );
          return;
        }
        if (!modelCostCenter.incidentalRate) {
          this.toastHandlerService.showToast(
            'warning',
            'El Porcentaje de Imprevistos es obligatorio'
          );
          return;
        }
        if (!modelCostCenter.utilityRate) {
          this.toastHandlerService.showToast(
            'warning',
            'El Porcentaje de Utilidad es obligatorio'
          );
          return;
        }
        if (!modelCostCenter.articleId) {
          this.toastHandlerService.showToast(
            'warning',
            'El Artículo AIU es obligatorio'
          );
          return;
        }
        if (!modelCostCenter.conceptInvoicingId) {
          this.toastHandlerService.showToast(
            'warning',
            'El Concepto AIU es obligatorio'
          );
          return;
        }
      }
      this.showValidationMessages();
    }
  }

  setArticleAIU(article: any) {
    this.formCostCenter.controls['articleId'].patchValue(article[0].articleId);
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'El campo Sucursal es obligatorio.'
      },
      code: {
        required: 'El campo Código es obligatorio.'
      },
      alterCode: {
        maxlength: 'El Código alterno no puede tener más de 10 caracteres.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El Nombre no puede tener más de 70 caracteres.'
      },
      costCenterTypeId: {
        required: 'El campo Tipo de centro de costos es obligatorio.',
        min: 'Debe seleccionar un Tipo de centro de costos válido.'
      },
      clientId: {
        required: 'El campo Cliente es obligatorio.'
      },
      constructionSiteId: {
        required: 'El campo Obra o Proyecto es obligatorio.'
      },
      priceListId: {
        required: 'El campo Lista de precios es obligatorio.',
        min: 'Debe seleccionar una Lista de precios válida.'
      },
      unitValueM2: {
        required: 'El valor unitario m² es obligatorio.',
        min: 'El valor unitario m² no puede ser negativo.'
      },
      valueFixedQuota: {
        min: 'La Cuota fija no puede ser negativa.',
        max: 'La Cuota fija supera el límite permitido (99.999.999.999,99).'
      },
      invoicingModelId: {
        required: 'El campo Modelo de facturación es obligatorio.',
        min: 'Debe seleccionar un Modelo de facturación válido.'
      },
      ivaTypeId: {
        required: 'El campo Tipo de IVA es obligatorio.',
        min: 'Debe seleccionar un Tipo de IVA válido.'
      },
      administrationRate: {
        min: 'El % de Administración no puede ser negativo.',
        max: 'El % de Administración no puede superar el 100%.'
      },
      incidentalRate: {
        min: 'El % de Imprevistos no puede ser negativo.',
        max: 'El % de Imprevistos no puede superar el 100%.'
      },
      utilityRate: {
        min: 'El % de Utilidad no puede ser negativo.',
        max: 'El % de Utilidad no puede superar el 100%.'
      },
      ratePromptPayment: {
        min: 'El % de Pronto pago no puede ser negativo.',
        max: 'El % de Pronto pago no puede superar el 100%.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };
    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formCostCenter.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForArticlesSelect$.next({
      headers: this.headerArticles,
      data: this.dataArticles,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: this.filtersArticle,
    });
  }

  updateFormPermision() {
    if (this.permissionUpdatable) {
      this.disabledButtonSave = false;
      setTimeout(() => this.formCostCenter.enable());
      setTimeout(() => this.formCostCenter.controls["code"].enable());
    } else {
      this.disabledButtonSave = true;
      setTimeout(() => this.formCostCenter.disable());
      setTimeout(() => this.formCostCenter.controls["code"].disable());
    }
  }

  async validateForm(costCenter: CostCenterModel) {
    this.formCostCenter = this.formBuilder.group({
      branchId: [costCenter.branchId, [Validators.required]],
      code: [costCenter.code, [Validators.required]],
      alterCode: [costCenter.alterCode, [Validators.maxLength(10)]],
      name: [costCenter.name, [Validators.required, Validators.maxLength(70)]],
      costCenterTypeId: [costCenter.costCenterTypeId, [Validators.required, Validators.min(1)]],
      clientId: [costCenter.clientId, [Validators.required]],
      constructionSiteId: [costCenter.constructionSiteId, [Validators.required]],
      priceListId: [costCenter.priceListId, [Validators.required, Validators.min(1)]],
      swInvoiceM2: [costCenter.swInvoiceM2],
      unitValueM2: [costCenter.unitValueM2, [Validators.required, Validators.min(0)]],
      swFixedQuota: [costCenter.swFixedQuota],
      valueFixedQuota: [costCenter.valueFixedQuota.toFixed(2), [Validators.min(0), Validators.max(99999999999.99)]],
      invoicingModelId: [costCenter.invoicingModelId, [Validators.required, Validators.min(1)]],
      ivaTypeId: [costCenter.ivaTypeId, [Validators.required, Validators.min(0)]],
      administrationRate: [costCenter.administrationRate.toFixed(2), [Validators.min(0), Validators.max(100)]],
      incidentalRate: [costCenter.incidentalRate.toFixed(2), [Validators.min(0), Validators.max(100)]],
      utilityRate: [costCenter.utilityRate.toFixed(2), [Validators.min(0), Validators.max(100)]],
      articleId: [costCenter.articleId],
      conceptInvoicingId: [costCenter.conceptInvoicingId],
      ratePromptPayment: [costCenter.ratePromptPayment.toFixed(2), [Validators.min(0), Validators.max(100)]],
      observation: [costCenter.observation, [Validators.maxLength(250)]],
      swAdvanceInvoice: [costCenter.swAdvanceInvoice],
      advanceInvoiceOption: [costCenter.advanceInvoiceOption],
      accountingModelId: [costCenter.accountingModelId],
    });
    const { costCenterId, ivaTypeId, constructionSiteId } = costCenter;
    this.updateFormPermision();
    if (costCenterId > 0) {
      await Promise.all([
        this.getIvaType(ivaTypeId),
        this.getEnterpriseAndClientByConstructionSiteIdAsync(constructionSiteId, false)
      ]);
    } else {
      setTimeout(() => this.formCostCenter.controls["code"].disable());
    }
    (['swInvoiceM2', 'swFixedQuota', 'swAdvanceInvoice'] as const).forEach(sw => {
      const value = costCenter[sw];
      this.onChange(value, sw);
    });
    if (this.ivaTypeId === IvaTypeEnums.pleno) {
      this.formCostCenter.controls["articleId"].disable();
    } else {
      this.formCostCenter.controls["articleId"].enable();
    }
  }
}
